'use strict';

var KeyMirror = require('keymirror');
var YesNoValues = require('./ApplicationConstants.js').YesNoValues;

const Labels = {
    setupOnlineAccess: 'Set up online access'
};

module.exports = {
    ActionTypes: KeyMirror({
        SAVE_ONLINE_ACCESS: null,
        PIN_VALIDATED: null,
        PIN_VALIDATED_ERROR: null,
        VALIDATE_PIN: null
    }),
    OnlineAccessData: {
		grantOnlineAccess: YesNoValues.YES,
		pin: '',
		confirmPin: '',
		secretQuestion: '',
		secretAnswer: '',
		confirmSecretAnswer: '',
        isLoadingComplete: true
	},
	OnlineAccessFieldErrorState: {
		pin: {
			hasValidated: null,
			weakPin: null
		}
	},
	Labels: Labels
};


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./constants/OnlineAccessConstants.js